import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

@Component({
    selector: 'st-beta',
    imports: [MatChip],
    templateUrl: './st-beta.component.html',
    styleUrl: './st-beta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-beta',
    },
})
export class BetaComponent {
    private store = inject(Store);

    //signals
    languageSettings = this.store.selectSignal(selectI18N);
}
